import type { ProviderProps } from './Context'
import { Provider, useContext } from './Context'

export const BaseLayout = (props: Omit<ProviderProps, 'children'>) => {
  return (
    <Provider {...props}>
      <RenderLayout />
    </Provider>
  )
}

// `components.layout` (chatComponents.tsx) is always present after the Provider's merge with
// the base defaults — DefaultLayout unless a mount overrides it.
const RenderLayout = () => {
  const { components } = useContext()

  return <components.layout />
}
